<template>
    <template v-if="media && !!media?.image">
        <img
            :src="media.image"
            :alt="`Full image`"
            class="media-content"
            @load="loaded"
            loading="lazy"
        >
        <div v-if="!isLoaded" class="loading">Loading...</div>
    </template>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
    name: "ImageViewer",
    props: {
        media: {
            type: [Object, Boolean],
            required: true,
            default: false
        }
    },
    data() {
        return {
            isLoaded: false
        }
    },
    methods: {
        loaded() {
            this.isLoaded = true;
        }
    }
})
</script>

<style scoped>

</style>